var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14.5C23.5 14.7652 23.3946 15.0196 23.2071 15.2071C23.0196 15.3946 22.7652 15.5 22.5 15.5H14.5C14.2348 15.5 13.9804 15.3946 13.7929 15.2071C13.6054 15.0196 13.5 14.7652 13.5 14.5C13.5 14.2348 13.6054 13.9804 13.7929 13.7929C13.9804 13.6054 14.2348 13.5 14.5 13.5H22.5C22.7652 13.5 23.0196 13.6054 23.2071 13.7929C23.3946 13.9804 23.5 14.2348 23.5 14.5ZM22.5 17.5H14.5C14.2348 17.5 13.9804 17.6054 13.7929 17.7929C13.6054 17.9804 13.5 18.2348 13.5 18.5C13.5 18.7652 13.6054 19.0196 13.7929 19.2071C13.9804 19.3946 14.2348 19.5 14.5 19.5H22.5C22.7652 19.5 23.0196 19.3946 23.2071 19.2071C23.3946 19.0196 23.5 18.7652 23.5 18.5C23.5 18.2348 23.3946 17.9804 23.2071 17.7929C23.0196 17.6054 22.7652 17.5 22.5 17.5ZM28.5 6.5V26.5C28.5 27.0304 28.2893 27.5391 27.9142 27.9142C27.5391 28.2893 27.0304 28.5 26.5 28.5H6.5C5.96957 28.5 5.46086 28.2893 5.08579 27.9142C4.71071 27.5391 4.5 27.0304 4.5 26.5V6.5C4.5 5.96957 4.71071 5.46086 5.08579 5.08579C5.46086 4.71071 5.96957 4.5 6.5 4.5H26.5C27.0304 4.5 27.5391 4.71071 27.9142 5.08579C28.2893 5.46086 28.5 5.96957 28.5 6.5ZM6.5 26.5H9.5V6.5H6.5V26.5ZM26.5 26.5V6.5H11.5V26.5H26.5Z",
    fill: "#3F41D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.53d32fd88dd2701fe187ad4678080494.svg";
export { ForwardRef as ReactComponent };